const team = [
  {
    name: 'Ammuna Abubakar',
    role: 'Founder & Executive Director',
    bio: 'The visionary founder of IKIRU Epilepsy Foundation, Ammuna Abubakar established the organization driven by a deep personal commitment to transforming epilepsy care and dismantling stigma across Nigeria and Africa.',
    img: 'https://storage.readdy-site.link/project_files/1c0c504f-5b8b-4291-9378-19346b5e3acb/23355b8b-23c4-4057-afc3-7facdfd4689c_WhatsApp-Image-2026-04-11-at-6.07.34-PM.jpeg?v=e21114373f32d607bc2ed10c1e28540c',
    socials: ['ri-linkedin-fill', 'ri-twitter-x-fill'],
  },
  {
    name: 'Yabawa Lawan Wabi',
    role: 'Director',
    bio: "A dedicated leader driving IKIRU's mission forward. Yabawa Lawan Wabi oversees the organization's strategic direction and operations, ensuring impactful programs that transform epilepsy care across Nigeria and Africa.",
    img: '/yabawa-lawan-wabi.jpg',
    socials: ['ri-linkedin-fill', 'ri-twitter-x-fill'],
  },
];

export default function LeadershipSection() {
  return (
    <section className="py-24 bg-[#1A0A1E]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="text-center mb-4">
          <span className="text-xs font-semibold uppercase tracking-[4px] text-[#C084FC]">The People Behind the Mission</span>
        </div>
        <h2 className="text-4xl md:text-5xl font-extrabold text-white text-center mb-4">
          Passionate <span className="text-[#C084FC]">Leadership</span>
        </h2>
        <p className="text-gray-400 text-center max-w-xl mx-auto mb-16 leading-relaxed">
          Led by experienced founders and specialists deeply dedicated to transforming epilepsy care across Africa.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-2xl mx-auto">
          {team.map((member) => (
            <div
              key={member.name}
              className="group bg-white/5 border border-purple-500/20 rounded-2xl overflow-hidden hover:border-[#7B2D8B]/60 transition-all duration-300 hover:-translate-y-1"
            >
              {/* Photo */}
              <div className="relative h-56 overflow-hidden">
                <img
                  src={member.img}
                  alt={member.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1A0A1E]/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-4">
                  <div className="flex gap-2">
                    {member.socials.map((icon) => (
                      <a
                        key={icon}
                        href="#"
                        rel="nofollow"
                        className="w-8 h-8 flex items-center justify-center rounded-full bg-[#7B2D8B] text-white cursor-pointer hover:bg-[#C084FC] transition-colors"
                      >
                        <i className={`${icon} text-xs`}></i>
                      </a>
                    ))}
                  </div>
                </div>
              </div>

              {/* Info */}
              <div className="p-5">
                <div className="text-xs font-semibold uppercase tracking-widest text-[#C084FC] mb-1">{member.role}</div>
                <h3 className="font-bold text-white text-base mb-3">{member.name}</h3>
                <p className="text-gray-500 text-xs leading-relaxed">{member.bio}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
